export default "__VITE_ASSET__ibF0rVd3__"